// General Images
import pic1 from './pic1.jpg'
import pic2 from './pic2.jpg';
import pic3 from './pic3.jpg';
import pic4 from './pic4.jpg';
import pic5 from './pic5.webp';
import pic from './pic.webp';
import image from './image.png';

// Icons and Logos
import email from './email.png';
import location from './location.png';
import telephone from './telephone.png';
import logoWeb from './logo-web.jpg';
import logo from './logo.png';
import home from './home.png';
import mission from './mission.png';
import vision from './vision.png';
import history from './history.png';

// Medical Images
import scalpel from './scalpel.png';
import surgery from './surgery.png';
import gyanaecology from './gyanaecology.png';
import urology from './urology.png';
import labscWebp from './labsc.webp';
import labscJpg from './labsc.jpg';

// Decorative
import branchLeaves from './branch-leaves.png';

export const images = {
  // General
  pic1,
  pic2,
  pic3,
  pic4,
  pic5,
  pic,
  image,

  // Icons & Logos
  email,
  location,
  telephone,
  logoWeb,
  logo,
  home,
  mission,
  vision,
  history,

  // Medical
  scalpel,
  surgery,
  gyanaecology,
  urology,
  labscWebp,
  labscJpg,

  // Decorative
  branchLeaves
};
